import { useOktaAuth } from '@okta/okta-react';
import schematicPNG from '../images/automation-hub.png';
import { Image } from 'semantic-ui-react';

const Home = () => {
  const { authState } = useOktaAuth();

  if (!authState || !authState.isAuthenticated) {
    return (
      <div style={{ marginTop: '20px', padding: '20px', zIndex: '1000' }}> Login into okta before continuing !</div>
    );
  } else {
    return (
      // <div style={{ marginTop: '10px', padding: '20px', zIndex: '1000' }}> <p> The Automation Hub platform serves as a comprehensive wrapper around automation testing,<br /> efficiently managing the scheduling of tests and maintaining builds and artifacts to streamline the entire e2e testing workflow.</p>
        <Image size="original" src={schematicPNG} style={{ maxWidth: '85%', height: 'auto' }} />
      // </div>
    )
  }
};

export default Home;